import keyMirror from 'keymirror'

export default keyMirror({
  GET_MOST_FREQUENT_QUESTIONS_REQUEST: null,
  GET_MOST_FREQUENT_QUESTIONS_SUCCESS: null,
  GET_MOST_FREQUENT_QUESTIONS_FAILED: null,

  GET_MOST_FREQUENT_QUESTION_DETAIL_REQUEST: null,
  GET_MOST_FREQUENT_QUESTION_DETAIL_SUCCESS: null,
  GET_MOST_FREQUENT_QUESTION_DETAIL_FAILED: null,

  DELETE_MOST_FREQUENT_QUESTION_REQUEST: null,
  DELETE_MOST_FREQUENT_QUESTION_SUCCESS: null,
  DELETE_MOST_FREQUENT_QUESTION_FAILED: null,

  ADD_MOST_FREQUENT_QUESTION_REQUEST: null,
  ADD_MOST_FREQUENT_QUESTION_SUCCESS: null,
  ADD_MOST_FREQUENT_QUESTION_FAILED: null,

  UPDATE_MOST_FREQUENT_QUESTION_REQUEST: null,
  UPDATE_MOST_FREQUENT_QUESTION_SUCCESS: null,
  UPDATE_MOST_FREQUENT_QUESTION_FAILED: null,

  UPDATE_MOST_FREQUENT_QUESTION_STATUS_REQUEST: null,
  UPDATE_MOST_FREQUENT_QUESTION_STATUS_SUCCESS: null,
  UPDATE_MOST_FREQUENT_QUESTION_STATUS_FAILED: null,

  UPDATE_FILTER_MOST_FREQUENT_QUESTION_SUCCESS: null,

  UPDATE_MOST_FREQUENT_QUESTION_SELECTED_LANGUAGES_SUCCESS: null,

  UPSERT_MOST_FREQUENT_QUESTION_TRANSLATION_REQUEST: null,
  UPSERT_MOST_FREQUENT_QUESTION_TRANSLATION_SUCCESS: null,
  UPSERT_MOST_FREQUENT_QUESTION_TRANSLATION_FAILED: null,

  GET_MOST_FREQUENT_QUESTION_CONTENT_REQUEST: null,
  GET_MOST_FREQUENT_QUESTION_CONTENT_SUCCESS: null,
  GET_MOST_FREQUENT_QUESTION_CONTENT_FAILED: null
})
